import { Button } from '@/components/ui'
import { useTranslations } from '@/lib/i18n'
import type { Pagination as PaginationData } from '@/types'

/**
 * Prev/next pager driven off current/total pages (the gateway's pagination contract).
 * `onNavigate(page)` lets the caller preserve filters in the URL.
 */
export function Pagination({
  pagination,
  onNavigate,
}: {
  pagination: PaginationData
  onNavigate: (page: number) => void
}) {
  const { t } = useTranslations()
  const { current_page, total_pages, total_items } = pagination

  if (total_pages <= 1) {
    return <p className="text-sm text-text/60">{t('pagination.total', { count: total_items })}</p>
  }

  return (
    <div className="flex items-center justify-between gap-4">
      <p className="text-sm text-text/60">
        {t('pagination.page_of', { current: current_page, total: total_pages })} ·{' '}
        {t('pagination.total', { count: total_items })}
      </p>
      <div className="flex gap-2">
        <Button plain disabled={current_page <= 1} onClick={() => onNavigate(current_page - 1)}>
          {t('pagination.previous')}
        </Button>
        <Button plain disabled={current_page >= total_pages} onClick={() => onNavigate(current_page + 1)}>
          {t('pagination.next')}
        </Button>
      </div>
    </div>
  )
}
